import type { AuthApi } from '@/api';

export type GiftTrialMe = NonNullable<
  NonNullable<
    Awaited<
      ReturnType<(typeof AuthApi)['get:/wello/v2/auth/gift-trial/me']>
    >['data']
  >['context']
>;

export type MemberStatus =
  | { type: 'ELIGIBLE' }
  | { type: 'NO_DONATION' }
  | { type: 'APPLIED_WAITING' }
  | { type: 'REVIEW_PENDING'; reviewApplicationId?: string }
  | { type: 'REVIEW_RESTRICTED' }
  | { type: 'UNAVAILABLE' };

export const resolveMemberStatus = ({
  profile,
  ongoingApplicationList,
}: Pick<GiftTrialMe, 'profile' | 'ongoingApplicationList'>): MemberStatus => {
  if (profile.restrictionType === 'NO_REVIEW_1Y') {
    return { type: 'REVIEW_RESTRICTED' };
  }
  if (profile.restrictionType && profile.restrictionType !== 'EXEMPTION') {
    return { type: 'UNAVAILABLE' };
  }

  //* 배송 전 선정도 같은 후기 안내를 보인다 — 후기 작성으로 바로 보낼 신청만 따로 담는다
  const selectedApplicationList = ongoingApplicationList.filter(
    (application) => application.applicationStatus === 'SELECTED',
  );

  if (selectedApplicationList.length > 0) {
    const reviewApplicationId = selectedApplicationList.find(
      (application) => application.canWriteReview,
    )?.applicationId;

    return reviewApplicationId
      ? { type: 'REVIEW_PENDING', reviewApplicationId }
      : { type: 'REVIEW_PENDING' };
  }
  if (ongoingApplicationList.length > 0) {
    return { type: 'APPLIED_WAITING' };
  }
  if (!profile.donationEligible) {
    return { type: 'NO_DONATION' };
  }

  return { type: 'ELIGIBLE' };
};
